import React, { useContext, useRef, useEffect } from 'react';

import { PagePropsContext } from '../App';
import { getCategoryImage, getRootCategoryId, getRootCategories, isDesktop } from '../utils/functions';

const Breadcrumb = () => {
  const { categories, selectedCategory, setSelectedCategory, setSelectedQuestion } = useContext(PagePropsContext);

  const pos = { x: 0, left: 0 };
  const breadcrumbListRef = useRef(null);

  // Effects
  useEffect(() => {
    if (!breadcrumbListRef.current) { return; }

    const activeItem = breadcrumbListRef.current.querySelector('.item--active');
    if (activeItem) {
      const scrollLeft = activeItem.offsetLeft - (breadcrumbListRef.current.offsetWidth / 2) + (activeItem.offsetWidth / 2);
      breadcrumbListRef.current.scrollLeft = scrollLeft;
    }
  }, [selectedCategory]);

  // Actions
  const mouseMoveHandler = (e) => {
    const dx = e.clientX - pos.x;
    breadcrumbListRef.current.scrollLeft = pos.left - dx;
  };

  const mouseDownHandler = (e) => {
    e.preventDefault();
    pos.x = e.clientX;
    pos.left = breadcrumbListRef.current.scrollLeft;

    document.addEventListener('mousemove', mouseMoveHandler);
    document.addEventListener('mouseup', mouseUpHandler);
    document.addEventListener('touchmove', mouseMoveHandler);
    document.addEventListener('touchend', mouseUpHandler);
  };

  const mouseUpHandler = () => {
    document.removeEventListener('mousemove', mouseMoveHandler);
    document.removeEventListener('mouseup', mouseUpHandler);
    document.removeEventListener('touchmove', mouseMoveHandler);
    document.removeEventListener('touchend', mouseUpHandler);
  };

  const handleClick = (cat) => {
    if (isDesktop()) {
      const children = categories.filter(c => c.parent_category === cat.id);
      if (children.length) {
        setSelectedCategory(children[0]);
        setSelectedQuestion(null);
      }
      return;
    }

    setSelectedCategory(cat);
    setSelectedQuestion(null);
  };

  return <div className='breadcrumb' onMouseDown={mouseDownHandler}>
    <ul ref={breadcrumbListRef} className='breadcrumb__list'>
      {getRootCategories(categories).map((cat, index) => {
        return <li
          key={cat.id}
          className={`breadcrumb__item${cat.id === getRootCategoryId(categories, selectedCategory?.id) ? ' item--active' : ''}`}
          onClick={() => handleClick(cat)}
        >
          <i className={`icon icon--${getCategoryImage(index)}`}></i>
          <span>{cat.name}</span>
        </li>;
      })}
    </ul>
  </div>;
}

export default Breadcrumb;
